
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hire-prompt-engineers",
      function () {
        return require("private-next-pages/hire-prompt-engineers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hire-prompt-engineers"])
      });
    }
  